import axios, { AxiosInstance, AxiosPromise } from 'axios';
import KeycloakService from '../services/KeycloakService';

export interface IServiceProxy {
    getLanguageList(contractId: string) : AxiosPromise;
    getFormData(documentId: string) : AxiosPromise; 
}

export interface IServiceProxyConfig{
    keycloakClient: KeycloakService;
}

export default class ServiceProxy implements IServiceProxy {
    private authedAxios: AxiosInstance;

    constructor(config : IServiceProxyConfig) {
        const kc = config.keycloakClient;
        this.authedAxios = axios.create();

        this.authedAxios.interceptors.request.use(config =>
            new Promise(function(resolve, reject) {
                kc.updateToken()
                  .then((token) => {
                      config.headers.Authorization = 'Bearer ' + token;
                      resolve(config);
                  }, () => {
                      // kc.login()
                      reject();
                  });
            })
        )
    }

    public getLanguageList(documentId: string) : AxiosPromise{
        console.log('Document ID: ' + documentId);
        return this.authedAxios.get(__CONTRACT_HOST__  + 'approved-language');
    }

    public getFormData(documentId: string) : AxiosPromise{
        return this.authedAxios.get(__WORKFLOW_HOST__ + 'documents/' + documentId + '/get-fields');
    }
}



// WEBPACK FOOTER //
// ./services/ServiceProxy.tsx